// Helper function to record Amplify analytics
import { Analytics } from 'aws-amplify'
import { getBuiltAttributes } from '@/utils/analytics/utils/multi-attributes'
import getUserSession from '@/utils/getUserSession'

const IDENTITY_POOL_ID = process.env.VUE_APP_IDENTITY_POOL_ID

export default async function recordAnalytics(
  { name = '', attributes = {}, metrics = {} } = {},
  extraData = null
) {
  const { user } = await getUserSession()
  const attrs = { ...attributes, department: user?.department || '', userId: user?.username }

  let eventBody = {
    name,
    attributes: attrs,
    metrics,
    event_timestamp: Date.now(),
    cognito_identity_pool_id: IDENTITY_POOL_ID
  }

  if (extraData) {
    eventBody = getBuiltAttributes(extraData, eventBody)
  }

  const kinesisEvent = {
    data: eventBody,
    streamName: process.env.VUE_APP_KINESIS_STREAM_NAME
  }
  Analytics?.record(kinesisEvent, 'AWSKinesis')
}
